// src/config.js
// const API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API_BASE_URL ="https://api.web-bunny.com"

export default API_BASE_URL;
